import WebService from "../WebService"

const Session = {
    create(data) {
        return WebService.post("/sessions", data)
    },
    updaveLiveStatus(data) {
        return WebService.post("/sessions/"+data.event_id+"/live_status", data)
    },
    getLives(params) {
        return WebService.get("/video?" + params)
    },
    upload(id, data) {
        return WebService.post("/sessions/" + id, data)
    },
    update(id, data) {
        return WebService.post("/sessions/" + id, data)
    }
}

export default Session